/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.regexp.constructor";
export var format = function format(date, fmt) {
  var obj = {
    'y{1,4}': date.getFullYear(),
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  };

  for (var exp in obj) {
    if (new RegExp("(".concat(exp, ")")).test(fmt)) {
      var res = obj[exp].toString();
      var $1 = RegExp.$1;
      fmt = fmt.replace($1, "0000".concat(res).substr(res.length + 4 - $1.length));
    }
  }

  return fmt;
};